<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .confirm {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: flex-start;
    justify-content: flex-start;
  }
</style>

<script>
  import Checkbox from "@sourcewhale/shared/svelte-design-system/components/atoms/Checkbox/Checkbox.svelte";
  import Label from "@sourcewhale/shared/svelte-design-system/components/atoms/InputLabels/Label.svelte";
  import { confirmedStore } from "./stores";

  const label =
    "Additional licenses become part of your contract in the same way as the licenses you started with. They will automatically renew for the contract term at the same time as the seats you started with, unless you give notice to terminate them before the automatic renewal. See your contract for the period of notice required. By ticking the checkbox you are confirming that you have authorization to agree to the above on behalf of your organization, that your organization is happy to make this purchase, and that you have understood the terms and conditions.";
</script>

<div class="confirm">
  <Checkbox bind:checked={$confirmedStore} required style="flex:1 0 auto" />
  <Label {label} labelSize="small" style="padding: 0" />
</div>
